/* src/app/components/doc-viewer-new/doc-viewer-content/doc-viewer-compare-content/doc-viewer-compare-content.component.scss */
::ng-deep .d2h-file-header {
  display: none;
}
/*# sourceMappingURL=doc-viewer-compare-content.component.css.map */
